export const PERMISSIONS = {
  LEADS: {
    VIEW_ALL: 'leads.view_all',
    VIEW_ASSIGNED: 'leads.view_assigned',
    CREATE: 'leads.create',
    EDIT: 'leads.edit',
    DELETE: 'leads.delete',
    ASSIGN: 'leads.assign',
    REASSIGN: 'leads.reassign',
    EXPORT: 'leads.export',
  },
  DOCUMENTS: {
    VIEW: 'documents.view',
    UPLOAD: 'documents.upload',
    DOWNLOAD: 'documents.download',
    DELETE: 'documents.delete',
    BULK_UPLOAD: 'documents.bulk_upload',
  },
  USERS: {
    VIEW_ALL: 'users.view_all',
    VIEW_TEAM: 'users.view_team',
    CREATE: 'users.create',
    EDIT: 'users.edit',
    DELETE: 'users.delete',
    MANAGE_PERMISSIONS: 'users.manage_permissions',
  },
  REPORTS: {
    VIEW: 'reports.view',
    CREATE: 'reports.create',
    EXPORT: 'reports.export',
    VIEW_ANALYTICS: 'reports.view_analytics',
  },
  CALLS: {
    VIEW_ALL: 'calls.view_all',
    VIEW_OWN: 'calls.view_own',
    MAKE: 'calls.make',
    SCHEDULE: 'calls.schedule',
  },
  SYSTEM: {
    ADMIN: 'system.admin',
    WEBHOOKS: 'system.webhooks',
    SETTINGS: 'system.settings',
  },
};

const ROLE_PERMISSIONS = {
  admin: [
    ...Object.values(PERMISSIONS.LEADS),
    ...Object.values(PERMISSIONS.DOCUMENTS),
    ...Object.values(PERMISSIONS.USERS),
    ...Object.values(PERMISSIONS.REPORTS),
    ...Object.values(PERMISSIONS.CALLS),
    ...Object.values(PERMISSIONS.SYSTEM),
  ],
  manager: [
    PERMISSIONS.LEADS.VIEW_ALL,
    PERMISSIONS.LEADS.CREATE,
    PERMISSIONS.LEADS.EDIT,
    PERMISSIONS.LEADS.ASSIGN,
    PERMISSIONS.LEADS.REASSIGN,
    PERMISSIONS.LEADS.EXPORT,
    PERMISSIONS.DOCUMENTS.VIEW,
    PERMISSIONS.DOCUMENTS.UPLOAD,
    PERMISSIONS.DOCUMENTS.DOWNLOAD,
    PERMISSIONS.DOCUMENTS.DELETE,
    PERMISSIONS.DOCUMENTS.BULK_UPLOAD,
    PERMISSIONS.USERS.VIEW_TEAM,
    PERMISSIONS.USERS.CREATE,
    PERMISSIONS.USERS.EDIT,
    PERMISSIONS.REPORTS.VIEW,
    PERMISSIONS.REPORTS.CREATE,
    PERMISSIONS.REPORTS.EXPORT,
    PERMISSIONS.CALLS.VIEW_ALL,
    PERMISSIONS.CALLS.MAKE,
    PERMISSIONS.CALLS.SCHEDULE,
  ],
  team_lead: [
    PERMISSIONS.LEADS.VIEW_ASSIGNED,
    PERMISSIONS.LEADS.EDIT,
    PERMISSIONS.LEADS.ASSIGN,
    PERMISSIONS.LEADS.REASSIGN,
    PERMISSIONS.DOCUMENTS.VIEW,
    PERMISSIONS.DOCUMENTS.UPLOAD,
    PERMISSIONS.DOCUMENTS.DOWNLOAD,
    PERMISSIONS.DOCUMENTS.DELETE,
    PERMISSIONS.DOCUMENTS.BULK_UPLOAD,
    PERMISSIONS.USERS.VIEW_TEAM,
    PERMISSIONS.USERS.CREATE,
    PERMISSIONS.USERS.EDIT,
    PERMISSIONS.REPORTS.VIEW,
    PERMISSIONS.CALLS.VIEW_ALL,
    PERMISSIONS.CALLS.MAKE,
    PERMISSIONS.CALLS.SCHEDULE,
  ],
  assistant_manager: [
    PERMISSIONS.LEADS.VIEW_ALL,
    PERMISSIONS.LEADS.CREATE,
    PERMISSIONS.LEADS.EDIT,
    PERMISSIONS.LEADS.ASSIGN,
    PERMISSIONS.LEADS.REASSIGN,
    PERMISSIONS.LEADS.EXPORT,
    PERMISSIONS.DOCUMENTS.VIEW,
    PERMISSIONS.DOCUMENTS.UPLOAD,
    PERMISSIONS.DOCUMENTS.DOWNLOAD,
    PERMISSIONS.DOCUMENTS.DELETE,
    PERMISSIONS.DOCUMENTS.BULK_UPLOAD,
    PERMISSIONS.USERS.VIEW_TEAM,
    PERMISSIONS.USERS.CREATE,
    PERMISSIONS.USERS.EDIT,
    PERMISSIONS.REPORTS.VIEW,
    PERMISSIONS.REPORTS.CREATE,
    PERMISSIONS.REPORTS.EXPORT,
    PERMISSIONS.CALLS.VIEW_ALL,
    PERMISSIONS.CALLS.MAKE,
    PERMISSIONS.CALLS.SCHEDULE,
  ],
  bda: [
    PERMISSIONS.LEADS.VIEW_ASSIGNED,
    PERMISSIONS.LEADS.EDIT,
    PERMISSIONS.DOCUMENTS.VIEW,
    PERMISSIONS.DOCUMENTS.UPLOAD,
    PERMISSIONS.DOCUMENTS.DOWNLOAD,
    PERMISSIONS.REPORTS.VIEW,
    PERMISSIONS.CALLS.VIEW_OWN,
    PERMISSIONS.CALLS.MAKE,
    PERMISSIONS.CALLS.SCHEDULE,
  ],
};

export const hasPermission = (userRole, permission) => {
  const rolePermissions = ROLE_PERMISSIONS[userRole] || [];
  return rolePermissions.includes(permission);
};

export const hasAnyPermission = (userRole, permissions) => {
  return permissions.some(permission => hasPermission(userRole, permission));
};

export const hasAllPermissions = (userRole, permissions) => {
  return permissions.every(permission => hasPermission(userRole, permission));
};

export const getUserPermissions = (userRole) => {
  return ROLE_PERMISSIONS[userRole] || [];
};
